import TimelineDotBase from '@mui/lab/TimelineDot';
import type { TimelineDotProps } from '@mui/lab/TimelineDot';

const TimelineDot = (props: TimelineDotProps) => (
  <TimelineDotBase
    {...props}
    sx={{
      m: 0,
      p: '2px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      background: 'white',
      border: '2px solid rgba(0, 0, 0, 0.2)',
      ...props.sx,
    }}
  />
);

export default TimelineDot;
